import styled from 'styled-components';

export const SectionContainer = styled.div`
  width: 100%;
  padding: 0px 15px;
  margin-top: 30px;
`;